import React from 'react';
import styled from 'styled-components';

interface TooltipProps {
  readonly children: React.ReactNode;
  readonly title: string | React.ReactNode;
  readonly testId?: string;
  readonly pos?: 'top' | 'bottom' | 'right' | 'left';
}

const StyledTooltipCnt = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;

  &:hover .tooltip-content {
    opacity: 1;
    pointer-events: auto;
  }
`;

const TooltipContent = styled.div<{ pos: 'top' | 'bottom' | 'right' | 'left' }>`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  text-align: center;
  background-color: rgb(55, 55, 55);
  color: #fff;
  padding: 5px 10px;
  width: max-content;
  max-width: 20ch;
  border-radius: 5px;
  z-index: 9999;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
  border: 1px solid rgba(255, 255, 255, 0.2);

  ${({ pos }) => {
    switch (pos) {
      case 'top':
        return `
        bottom: calc(100% + 10px);
        top: auto;
        left: 50%;
        transform: translateX(-50%);
      `;
      case 'bottom':
        return `
        top: calc(100% + 10px);
        bottom: auto;
        left: 50%;
        transform: translateX(-50%);
      `;
      case 'left':
        return `
        right: calc(100% + 10px);
        left: auto;
        top: 50%;
        transform: translateY(-50%);
      `;
      case 'right':
        return `
        left: calc(100% + 10px);
        right: auto;
        top: 50%;
        transform: translateY(-50%);
      `;
      default:
        return '';
    }
  }}
`;

export const Tooltip = ({
  children,
  title,
  testId,
  pos = 'bottom',
}: TooltipProps) => {
  return (
    <StyledTooltipCnt className="tooltip-cnt">
      {children}
      <TooltipContent
        className="tooltip-content"
        data-testid={testId}
        data-title={title}
        pos={pos}
      >
        {title}
      </TooltipContent>
    </StyledTooltipCnt>
  );
};
